module.exports = __webpack_public_path__ + "static/media/banner.15c53068.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/banner.png
// module id = 634
// module chunks = 0